module.exports = __webpack_public_path__ + "img/step-ok.74cb7d21.svg";